<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="submission">
            <van-nav-bar
                :title="title"
                left-text="审批办理"
                left-arrow
                v-if="isNews != true"
                @click-left="swiperright"
            >
            </van-nav-bar>
            <section :class="{'isNews': isNews}">
                <van-overlay :show="loadingShow" @click="show = false">
                    <van-loading type="spinner" color="#fff"></van-loading>
                </van-overlay>
                <div class="linkNode" v-if="submissionMethod != 'role'">
                    <h4>
                        <span>选择节点</span>
                        <div>
                            <button v-if="nodeState" @click="nodeState = false">
                                展开
                                <i class="iconfont icondown"></i>
                            </button>
                            <button v-else @click="nodeState = true">
                                收起
                                <i class="iconfont iconup"></i>
                            </button>
                        </div>
                    </h4>
                    <ul v-if="!nodeState">
                        <template v-for="(item, index) in nodeData">
                            <li
                                :key="`node_${index}`"
                                :class="{'active': currentNode == index, 'countersignatureNode': item.node_type == 3}"
                                @click="selectNode(index, item, 'node')"
                            >
                                <div v-if="item.node_type == 3">
                                    <i>会</i>
                                    <span>会签审核</span>
                                </div>
                                <span v-else>{{ item.data[0].BusinessPhaseName }}</span>
                            </li>
                        </template>
                    </ul>
                    <ol v-if="countersignNodeData.length > 0">
                        <template v-for="(item, index) in countersignNodeData">
                            <li
                                :key="index"
                                :class="{'active': currentCountersignatureNode === index}"
                                @click="selectNode(index, item, 'childNode')"
                            >
                                <div class="nodeNmame">
                                    <span class="iconfont iconxuanze1" :class="{'selected': item.ApproverName.length>0}"></span>
                                    {{ item.BusinessPhaseName }}
                                    <i v-if="item.IsRequired == 1">*</i>
                                </div>
                                <div class="noedeUser">
                                    已选：
                                    <template v-for="(k, i) in item.ApproverName">
                                        <span :key="i">{{ k }}</span>
                                    </template>
                                </div>
                            </li>
                        </template>
                    </ol>
                </div>
                <div
                    class="personnelList"
                    v-if="!isCrossHierarchy && nodeApproverCategory == 2 && !isBack || submissionMethod === 'role'"
                >
                    <h4>选择成员</h4>
                    <van-collapse v-model="selectRole" accordion @change="obtainPersonnel">
                        <template v-for="(k, j) in approverRoleName">
                            <van-collapse-item :key="`countersigningLink_${j}`">
                                <template #title>
                                    <i class="iconfont iconjiedian"></i>
                                    <span>{{ k }}</span>
                                </template>
                                <van-index-bar :index-list="indexList" :sticky="false" v-if="selectRole === j">
                                    <template v-for="(item, index) in waitMembersData">
                                        <div :key="`personnelClassList_${index}`" class="personnelClassList">
                                            <van-index-anchor class="personnelClassInitial" :index="item.Initial"></van-index-anchor>
                                            <template v-if="isRadio">
                                                <van-radio-group v-model="radioChosedMembers" @change="handleCheckedWaitChange(item.data)">
                                                    <template v-for="(z, i) in item.data">
                                                        <van-radio
                                                            :key="i"
                                                            :name="z.user_id"
                                                            icon-size="18px"
                                                        >
                                                            {{ z.user_name }}
                                                        </van-radio>
                                                    </template>
                                                </van-radio-group>
                                            </template>
                                            <template v-else>
                                                <van-checkbox-group v-model="result">
                                                    <template v-for="(z, i) in item.data">
                                                        <van-checkbox :key="i" v-model="checked">
                                                            {{ z.user_name }}
                                                        </van-checkbox>
                                                    </template>
                                                </van-checkbox-group>
                                            </template>
                                        </div>
                                    </template>
                                </van-index-bar>
                            </van-collapse-item>
                        </template>
                    </van-collapse>
                </div>
                <div class="personnelIdentified" v-else>
                    <ul v-if="approverRoleName.length > 0">
                        <template v-for="(item, index) in approverRoleName">
                            <li :key="index">
                                <span class="state iconfont iconjiaobiao"><i>已选</i></span>
                                <div class="headPortrait van_left">
                                    <img src="@/assets/images/addressBook/b_head_portrait_man@2x.png" alt="">
                                </div>
                                <div class="info van_left">
                                    <h5>{{ item }}</h5>
                                    <!-- <p>销售主管</p> -->
                                </div>
                            </li>
                        </template>
                    </ul>
                </div>
                <van-dialog
                    v-model="confirmedByShow"
                    title="提交确认"
                    show-cancel-button
                    @cancel="cancelSubmission"
                    @confirm="confirmSubmission"
                    class="submitPopUp"
                >
                    <div class="submitPopUpContent">
                        <div class="info" v-if="submissionMethod === 'role'">
                            <div class="infoList approver">
                                <i class="icon iconfont icon04gerenfill"></i>
                                <h4 v-if="NextApproverNames !=''">
                                    <p>审批人：</p>
                                    <span>{{ NextApproverNames }}</span>
                                </h4>
                            </div>
                        </div>
                        <div class="info linkInfo" v-else>
                            <div class="infoList approvalPhase">
                                <i class="icon iconfont iconshenpi"></i>
                                <h4 v-if="currentNodeName !=''">
                                    <p>下一环节：</p>
                                    <span>{{ currentNodeName }}</span>
                                </h4>
                            </div>
                            <div class="infoList approver">
                                <i class="icon iconfont icon04gerenfill"></i>
                                <h4 v-if="NextApproverNames !=''">
                                    <p>审批人：</p>
                                    <span>{{ NextApproverNames }}</span>
                                </h4>
                            </div>
                        </div>
                    </div>
                    <p class="tips">
                        是否确认提交？
                    </p>
                </van-dialog>
            </section>
            <div class="btns">
                <van-button
                    block
                    type="primary"
                    @click="submission"
                >
                    提交
                </van-button>
            </div>
        </div>
    </v-touch>
</template>
<script>

export default {
    name: '',
    components: {},
    props: {},
    data() {
        return {
            // 父页面传递数据
            parentData: {},
            // 页面标题
            title: '',
            // 提交方式
            submissionMethod: '',
            // 流程数据（自由提交提交）
            processData: {},
            // 当前环节标识（自由提交提交）
            businessPhaseId: '',
            // 环节数据集合
            nodeData: [],
            // 当前选择环节下标
            currentNode: 0,
            // 当前选择环节数据
            currentNodeData: {},
            // 当前环节id
            currentNodeId: '',
            // 当前环节类型
            nodeType: 0,
            // 当前选择环节名称
            currentNodeName: '',
            // 会签节点数据
            countersignNodeData: [],
            // 会签节点选中下标
            currentCountersignatureNode: 0,
            // 当前环节审批人类别
            nodeApproverCategory: 0,
            // 是否允许修改办理人
            isAllowEditApprover: false,
            // 是否是跨级审批
            isCrossHierarchy: false,
            // 环节审批角色id
            approverRoleId: [],
            // 环节审批角色name
            approverRoleName: [],
            // 是否单选
            isRadio: true,
            // 角色下所有人员
            allWaitingMemberData: [],
            // 角色下人员
            waitMembersData: [],
            // 索引数组
            indexList: [],
            // 已选-单选
            radioChosedMembers: '',
            // 下一环节审批人id集合
            NextApproverIds: '',
            // 下一环节审批人name集合
            NextApproverNames: '',
            // 确认人员弹出层状态
            confirmedByShow: false,
            // 加载中状态
            loadingShow: false,
            // 人员提交数据
            ApiData: {},
            // 流程id
            BusinessInstanceId: '',
            // 是否是消息跳转审批
            isNews: false,
            // 节点状态（true收起，fal展开）
            nodeState: false,
            // 退回
            isBack: null,
            newsToken: '',
            // 人员是否按部门过滤
            isDeptFilter: false,
            // 部门类型
            deptFilterType: '',

            selectRole: 0,
        };
    },
    computed: {},
    watch: {},
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        initpage() {
            this.parentData = this.$route.params.data;
            this.isNews = this.$route.params.isNews;
            this.newsToken = this.$route.params.thisToken;
            this.title = this.parentData.title;
            this.submissionMethod = this.parentData.type;
            // 读取父页面流程数据
            this.processData = JSON.parse(JSON.stringify(this.parentData.processData));
            // 人员是否按部门过滤
            this.isDeptFilter = this.processData.CurrentBusinessProcess?.SubmitPhaseModel?.IsDeptFilter;
            // 部门类型
            this.deptFilterType = this.processData.CurrentBusinessProcess?.SubmitPhaseModel?.DeptFilterType;
            // 流程id
            this.BusinessInstanceId = this.processData.BusinessInstanceInfo.BusinessInstanceId;
            // type等于role普通提交，link自由提交(只能选当前环节后面环节)，linkBtn自由提交（可以选择所有环节）
            if (this.submissionMethod === 'role') {
                if (this.processData.CurrentBusinessProcess.SubmitPhaseModel) {
                    this.approverRoleId = this.processData.CurrentBusinessProcess.SubmitPhaseModel.ApproverRoleId.split(',');
                    this.approverRoleName = this.processData.CurrentBusinessProcess.SubmitPhaseModel.ApproverRoleName.split(',');
                }
                // 初始化第一个角色数据
                this.obtainPersonnel(0);
            } else if (this.submissionMethod === 'countersign') {
            // 当前选择环节名称
                this.currentNodeName = '会签审核';
                if (this.processData.CurrentBusinessProcess.SubmitPhaseNodes) {
                    this.processingLinkData(this.processData.CurrentBusinessProcess.SubmitPhaseNodes);
                } else {
                // 初始化第一个角色数据
                    this.obtainPersonnel(0);
                }
            } else if (['link', 'linkBtn'].indexOf(this.submissionMethod) > -1) {
                this.businessPhaseId = this.processData.CurrentBusinessProcess.BusinessPhaseId;
                // 获取节点数据
                this.gitNodeData(this.submissionMethod);
                // 初始化第一个角色数据
                this.obtainPersonnel(0);
            }
        },
        // 返回上一页
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },
        // 获取节点数据
        async gitNodeData(type) {
            let getUrl = '';
            if (type === 'link') {
                getUrl = `/interfaceApi/basicplatform/simpleflow/processes/phases/new/${this.businessPhaseId}`;
            } else if (type === 'linkBtn') {
                getUrl = `/interfaceApi/basicplatform/simpleflow/processes/phases_other/new/${this.businessPhaseId}`;
            }
            const res = await this.gitNodeDataRequest(getUrl);
            this.processingLinkData(res);
        },
        // 处理环节数据
        processingLinkData(res) {
            const newData = res;
            newData.forEach(k => {
                k.data.forEach(item => {
                    // 审批人id
                    if (item.ApproverId) {
                        item.ApproverId = item.ApproverId.split(',');
                    } else {
                        item.ApproverId = [];
                    }
                    // 审批人name
                    if (item.ApproverName) {
                        item.ApproverName = item.ApproverName.split(',');
                    } else {
                        item.ApproverName = [];
                    }
                    // 审批角色id
                    if (item.ApproverRoleId) {
                        item.ApproverRoleId = item.ApproverRoleId.split(',');
                    } else {
                        item.ApproverRoleId = [];
                    }
                    // 审批角色name
                    if (item.ApproverRoleName) {
                        item.ApproverRoleName = item.ApproverRoleName.split(',');
                    } else {
                        item.ApproverRoleName = [];
                    }
                });
            });
            // 环节数据
            this.nodeData = newData;
            // 环节类型
            this.nodeType = this.nodeData[0].node_type;
            const row = this.nodeData[0].data[0];
            // 是否是退回
            this.isBack = this.nodeData[0].is_back;
            // 当前环节审批人类别
            this.nodeApproverCategory = row.ApproverType;
            // 当前环节id
            this.currentNodeId = row.BusinessPhaseId;
            // 当前环节数据
            this.currentNodeData = row;
            // 是否允许修改办理人;
            this.isAllowEditApprover = row.IsAllowEditApprover;
            let user_id = [];
            let user_name = [];
            if (this.nodeType === 3) {
                this.currentNodeName = '会签审核';
                // 会签节点数据
                this.countersignNodeData = newData[0].data;
                this.currentCountersignatureNode = 0;
                this.nodeData[0].data.forEach(k => {
                    if (k.ApproverId && k.ApproverId.length > 0) {
                        user_id.push(...k.ApproverId.toString());
                    }
                    if (k.ApproverName && k.ApproverName.length > 0) {
                        user_name.push(...k.ApproverName.toString());
                    }
                });
            } else {
                this.currentNodeName = row.BusinessPhaseName;
                this.countersignNodeData = [];
                if (row.ApproverId && row.ApproverId.length > 0) {
                    user_id = row.ApproverId[0].toString();
                }
                if (row.ApproverName && row.ApproverName.length > 0) {
                    user_name = row.ApproverName[0].toString();
                }
            }

            this.isCrossHierarchy = newData[0].IsCrossHierarchy;
            if (this.isCrossHierarchy !== true) {
                // 过滤审批人类别数据
                if (this.isBack) {
                    this.filterData_back(row);
                } else {
                    this.filterData(row);
                }
            }
        },
        // 过滤审批人类别数据
        filterData(data) {
            if (this.nodeApproverCategory === 1) {
                // 默认第一个环节id赋值
                if (data.ApproverId) {
                    this.approverRoleId.push(...data.ApproverId);
                }
                // 默认第一个环节名称赋值
                if (data.ApproverName) {
                    this.approverRoleName.push(...data.ApproverName);
                }
            } else if (this.nodeApproverCategory === 2) {
                // 默认第一个环节id赋值
                if (data.ApproverRoleId) {
                    this.approverRoleId.push(...data.ApproverRoleId);
                }
                // 默认第一个环节名称赋值
                if (data.ApproverRoleName) {
                    this.approverRoleName.push(...data.ApproverRoleName);
                }
                // 默认拉取第一个角色下人员
                this.obtainPersonnel(0, data);
            }
        },
        // 过滤审批人类别数据-已审环节[自由提交选择已提交环节]
        filterData_back(data) {
            if (data.HandledUsers?.length > 0) {
                const row = data.HandledUsers[data.HandledUsers.length - 1];
                this.approverRoleId.push(row.ApproverId);
                this.approverRoleName.push(row.ApproverName);
            } else if (this.nodeApproverCategory === 1) {
                this.approverRoleId.push(...data.ApproverId);
                this.approverRoleName.push(...data.ApproverName);
                this.loading = false;
            } else if (this.nodeApproverCategory === 2) {
                // 默认第一个环节id赋值
                if (data.ApproverRoleId) {
                    this.approverRoleId.push(...data.ApproverRoleId);
                }
                // 默认第一个环节名称赋值
                if (data.ApproverRoleName) {
                    this.approverRoleName.push(...data.ApproverRoleName);
                }
                // 默认拉取第一个角色下人员
                this.obtainPersonnel(0, data);
            }
        },
        // 获取角色下人员
        async obtainPersonnel(index, row) {
            if (index === '') {return;}
            const roleid = this.approverRoleId[index];
            const deptType = row?.DeptType;
            const parameter = `businessInstanceId=${this.BusinessInstanceId}&roleId=${roleid}&deptType=${deptType}`;
            const res = await this.obtainPersonnelRequest(parameter);
            this.allWaitingMemberData = JSON.parse(JSON.stringify(res));
            // 处理数据
            const newData = this.$dataSorting(res, 'user_name');
            // 角色下人员数据赋值
            this.waitMembersData = newData.dataList;
            // 索引数组赋值
            this.indexList = newData.indexList;
            this.$forceUpdate();

            if (row && (row.ApproverId || []).length > 0) {
                this.radioChosedMembers = row.ApproverId[0];
            } else {
                this.radioChosedMembers = '';
            }
        },
        // 选择节点
        selectNode(index, row, type) {
            // 环节审批角色name
            this.approverRoleName = [];
            // 角色下人员
            this.waitMembersData = [];

            this.approverRoleId = [];
            this.NextApproverIds = '';
            this.NextApproverNames = '';

            if (type === 'node') {
                // 当前选择环节下标
                this.currentNode = index;
                // 当前环节类型
                this.nodeType = row.node_type;
                // 当前选择环节数据
                this.currentNodeData = row.data[0];
                // 是否是退回
                this.isBack = row.is_back;
                if (row.node_type === 3) {
                    // 当前选择环节名称
                    this.currentNodeName = '会签审核';
                    this.countersignNodeData = row.data;
                    this.currentCountersignatureNode = 0;
                } else {
                    this.countersignNodeData = [];
                    // 当前选择环节名称
                    this.currentNodeName = this.currentNodeData.BusinessPhaseName;
                }
            } else {
                this.currentCountersignatureNode = index;
                this.currentNodeData = row;
            }

            // 当前环节审批人类别
            this.nodeApproverCategory = this.currentNodeData.ApproverType;
            // 当前环节id
            this.currentNodeId = this.currentNodeData.BusinessPhaseId;
            // 是否允许修改办理人;
            this.isAllowEditApprover = this.currentNodeData.IsAllowEditApprover;
            // 是否是跨级审批
            this.isCrossHierarchy = this.currentNodeData.IsCrossHierarchy;
            if (this.isCrossHierarchy !== true) {
                // 过滤审批人类别数据
                if (this.isBack) {
                    this.filterData_back(this.currentNodeData);
                } else {
                    this.filterData(this.currentNodeData);
                }
            }
        },
        // 选择成员
        handleCheckedWaitChange() {
            this.currentNodeData.ApproverId = [];
            this.currentNodeData.ApproverName = [];
            this.allWaitingMemberData.forEach(item => {
                if (item.user_id === this.radioChosedMembers) {
                    if (this.isRadio) {
                        this.currentNodeData.ApproverId.push(item.user_id);
                        this.currentNodeData.ApproverName.push(item.user_name);
                    }
                }
            });
        },
        // 提交
        submission() {
            this.ApiData = {};
            const idS = [];
            const nameS = [];
            let new_transferMode = null;
            if (this.isBack) { // 提交已审批环节，退回状态
                new_transferMode = 21;
            } else {
                new_transferMode = 10;
            }
            if (this.submissionMethod === 'role') {
                if ((this.currentNodeData?.ApproverId || []).length > 0) {
                    idS.push(...this.currentNodeData?.ApproverId);
                    nameS.push(...this.currentNodeData?.ApproverName);
                }
            } else if (this.nodeData[this.currentNode].is_back) {
                this.nodeData[this.currentNode].data.forEach(k => {
                    const row = k.HandledUsers[k.HandledUsers.length - 1];
                    if (row) {
                        idS.push(row.ApproverId);
                        nameS.push(row.ApproverName);
                    }
                });
            } else {
                this.nodeData[this.currentNode].data.forEach(k => {
                    if (k.ApproverId) {
                        idS.push(...k.ApproverId);
                    }
                    if (k.ApproverName) {
                        nameS.push(...k.ApproverName);
                    }
                });
            }
            this.NextApproverIds = idS.toString();
            this.NextApproverNames = nameS.toString();

            // 判断是否有下一环节审批人id集合和下一环节审批人name集合，有值进行提交
            if (this.NextApproverIds !== '' || this.NextApproverNames !== '' || this.isCrossHierarchy === true) {
                if (this.submissionMethod === 'role') {
                    this.ApiData = {
                        BusinessInstanceId: this.BusinessInstanceId,
                        CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                        TransferMode: new_transferMode,
                        NextApproverIds: this.NextApproverIds,
                        NextApproverNames: this.NextApproverNames,
                    };
                } if (this.submissionMethod === 'countersign') { // 会签节点提交
                    const currentlySelectedNodeData = [];
                    this.nodeData[this.currentNode].data.forEach(item => {
                        currentlySelectedNodeData.push({
                            NextPhsaeId: item.BusinessPhaseId,
                            NextApproverIds: item.ApproverId.toString(),
                            NextApproverNames: item.ApproverName.toString(),
                        });
                    });
                    this.ApiData = {
                        BusinessInstanceId: this.BusinessInstanceId,
                        CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                        TransferMode: new_transferMode,
                        NextPhsaeId: '',
                        NextApproverIds: '',
                        NextApproverNames: '',
                        MultiPhase: currentlySelectedNodeData,
                    };
                } else if (this.submissionMethod === 'link') {
                    if (this.nodeApproverCategory === 1) {
                        // 跨级审批
                        this.ApiData = {
                            BusinessInstanceId: this.BusinessInstanceId,
                            CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                            TransferMode: new_transferMode,
                            NextPhsaeId: this.currentNodeId,
                            NextApproverIds: this.NextApproverIds,
                            NextApproverNames: this.NextApproverNames,
                        };
                    } else if (this.nodeApproverCategory === 2) {
                        if (this.isAllowEditApprover) {
                            this.ApiData = {
                                BusinessInstanceId: this.BusinessInstanceId,
                                CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                                TransferMode: new_transferMode,
                                NextPhsaeId: this.currentNodeId,
                                NextApproverIds: this.NextApproverIds,
                                NextApproverNames: this.NextApproverNames,
                            };
                        } else {
                            this.ApiData = {
                                BusinessInstanceId: this.BusinessInstanceId,
                                CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                                TransferMode: new_transferMode,
                                NextPhsaeId: this.currentNodeId,
                                NextApproverIds: null,
                                NextApproverNames: null,
                            };
                        }
                    }
                } else if (this.submissionMethod === 'linkBtn') { // 自由提交按钮提交
                    if (this.nodeType === 3) {
                        const currentlySelectedNodeData = [];
                        const row = JSON.parse(JSON.stringify(this.countersignNodeData));
                        row.forEach(item => {
                            if (item.ApproverId) {
                                item.ApproverId = item.ApproverId.toString();
                            }
                            // 审批人name
                            if (item.ApproverName) {
                                item.ApproverName = item.ApproverName.toString();
                            }
                            // 审批角色id
                            if (item.ApproverRoleId) {
                                item.ApproverRoleId = item.ApproverRoleId.toString();
                            }
                            // 审批角色name
                            if (item.ApproverRoleName) {
                                item.ApproverRoleName = item.ApproverRoleName.toString();
                            }
                            currentlySelectedNodeData.push({
                                NextPhsaeId: item.BusinessPhaseId,
                                NextApproverIds: item.ApproverId,
                                NextApproverNames: item.ApproverName,
                            });
                        });

                        this.ApiData = {
                            BusinessInstanceId: this.BusinessInstanceId,
                            CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                            TransferMode: new_transferMode,
                            NextPhsaeId: this.currentNodeId,
                            NextApproverIds: null,
                            NextApproverNames: null,
                            MultiPhase: currentlySelectedNodeData,
                        };
                    } else {
                        this.ApiData = {
                            BusinessInstanceId: this.BusinessInstanceId,
                            CurrentBusinessProcessId: this.processData.CurrentBusinessProcess.CurrentBusinessProcessId,
                            TransferMode: new_transferMode,
                            NextPhsaeId: this.currentNodeId,
                            NextApproverIds: this.NextApproverIds,
                            NextApproverNames: this.NextApproverNames,
                        };
                    }
                }
                this.confirmedByShow = true;
            } else {
                this.$toast('请先选择人员！');
            }
        },
        // 取消提交
        cancelSubmission() {
            this.NextApproverIds = '';
            this.NextApproverNames = '';
            this.radioChosedMembers = '';
            this.$toast('已取消！');
        },
        // 确认提交
        confirmSubmission() {
            this.submitAPI(this.ApiData);
        },
        // 流程提交
        async submitAPI(data) {
            this.loadingShow = true;
            const res = await this.submitAPIRequest(data);
            if (res) {
                this.$toast.success('提交成功！');
                this.NextApproverIds = '';
                this.NextApproverNames = '';
                this.radioChosedMembers = '';
                this.$router.isBack = 1;
                this.$router.replace({
                    name: this.$route.params.backPathName,
                    params: {
                        isRefresh: true,
                    },
                });
                if (this.isNews !== true) {
                    this.$store.commit('noKeepAlive', 'approval-process');
                }
            }
            this.loadingShow = false;
        },


        // 获取节点数据请求
        gitNodeDataRequest(getUrl) {
            return this.$axios.$get(getUrl, { token: this.newsToken });
        },

        // 获取角色下人员请求
        obtainPersonnelRequest(parameter) {
            const url = `/interfaceApi/basicplatform/simpleflow/processes/getphaseroleuser?${parameter}`;
            return this.$axios.$get(url, { token: this.newsToken });
        },

        // 流程提交请求
        submitAPIRequest(data) {
            return this.$axios.$post('/interfaceApi/basicplatform/simpleflow/processes', data, { token: this.newsToken });
        },
    },
};
</script>
<style lang="stylus">
.submission
    height 100%
    section
        height calc(100% - 105rpx)
        overflow auto
        position relative
        &.isNews
            height calc(100% - 60rpx)
        .van-loading
            position absolute
            top 50%
            left 50%
            z-index 9
            transform translate(-50% , -50%)
        .linkNode
            padding 15rpx
            border-bottom 2px solid #F0F0F0
            h4
                font-size 16rpx
                color #001A2C
                font-weight: 600;
                display flex
                justify-content space-between
                div
                    button
                        height 24rpx
                        padding 0 8rpx
                        font-size 12rpx
                        color #0078FB
                        font-weight: 500;
                        background: rgba(0,120,251,0.06);
                        border-radius: 2px;
                        border: 1px solid rgba(0,120,251,0.1);
                        i
                            font-size 12rpx
            ul
                display flex
                flex-wrap wrap
                justify-content space-between
                li
                    padding 0 10rpx
                    overflow hidden
                    border-radius 4px
                    border 1px solid #D7D7D7
                    font-size 14rpx
                    line-height 32rpx
                    text-align center
                    position relative
                    margin-top 10rpx
                    background #F8F8F8
                    &.active
                        border none
                        color #fff
                        background #0078FB
                        i
                            display block
                    &.countersignatureNode
                        position relative
                        padding 0 4rpx
                        >div
                            display flex
                            align-items center
                            i
                                width 24rpx
                                height 24rpx
                                background #E2EFFF
                                font-size 14rpx
                                color #1080FB
                                line-height 24rpx
                                border-radius: 4rpx;
                                margin-right 8rpx
                                font-weight: 500;
                        &.active
                            >div
                                i
                                    background #fff
                                    color #1080FB
                                    font-weight: 600;
            ol
                margin-top 10rpx
                border 1px solid rgba(0, 120, 251, 0.1600)
                border-radius 4px
                padding 10rpx
                li
                    display flex
                    flex-wrap wrap
                    min-width calc(100%/3 - 14rpx)
                    margin-bottom 10rpx
                    &:last-child
                        margin-bottom 0
                    div
                        height 32rpx
                        line-height 32rpx
                        color #694016
                    .nodeNmame
                        width 130rpx
                        position relative
                        font-size 14rpx
                        color #4F81B7
                        text-align center
                        border 1px solid #D3E3F6
                        border-radius 4px
                        margin-right 10rpx
                        span
                            color rgba(0, 120, 251, 0.3)
                            &.selected
                                color #0078FB
                        i
                            font-size 0.28rem
                            color #F64A2C
                            vertical-align: top;
                    .noedeUser
                        width calc(100% - 148rpx)
                        font-size 12rpx
                        color #4F81B7
                        border-radius 4px
                        background #F1F8FF
                        border-radius 4rpx
                        padding 0 10rpx
                    &.btns
                        width 100%
                        line-height 26rpx
                        height 26rpx
                        text-align center
                        font-size 12rpx
                        color #666666
                        vertical-align middle
                    &.active
                        .nodeNmame
                            background #0078FB
                            color #FFFFFF
                            border none
                            span
                                color rgba(255, 255, 255, 0.3)
                                &.selected
                                    color #FFFFFF
                        .noedeUser
                            background #E4F0FF
                            color #0078FB
        .personnelList
            width 100%
            overflow hidden
            >h4
                font-size 16rpx
                color #001A2C
                line-height 46rpx
                padding 0 15rpx
                font-weight 600
            .van-collapse
                .van-collapse-item
                    .van-cell
                        .van-cell__title
                            i
                                font-size 14rpx
                                color #999999
                                margin-right 10rpx
                            span
                                font-size 16rpx
                                color #333333
                        &.van-collapse-item__title--expanded
                            .van-cell__title
                                i
                                    color #4F81B7
                                span
                                    color #4F81B7
                            .van-cell__right-icon
                                color #4F81B7
                    .van-collapse-item__wrapper
                        overflow: initial;
                        .van-collapse-item__content
                            padding 0
                            .van-index-bar
                                position relative
                                .van-index-bar__sidebar
                                    position absolute
                                .personnelClassList
                                    display flex
                                    .personnelClassInitial
                                        width 45rpx
                                        background: rgba(0,120,251,0.06);
                                        border: 1px solid rgba(0,120,251,0.1);
                                        .van-index-anchor
                                            color #4F81B7
                                            font-size 14rpx
                                    .van-radio-group
                                        width calc(100% - 45rpx)
                                        .van-radio
                                            height 40rpx
                                            line-height 40rpx
                                            background #FAFCFF
                                            padding-left 15rpx
                                            border-bottom 1px solid #F0F0F0
        .personnelIdentified
            width 100%
            overflow hidden
            ul
                height 100%
                background #F0F0F0
                padding 15rpx
                li
                    height 72rpx
                    padding 15rpx
                    background #fff
                    position relative
                    box-shadow 0 2px 8px rgba(52, 149, 251, 0.5)
                    .state
                        position absolute
                        top 0
                        right 0
                        font-weight 400
                        width 40rpx
                        height 40rpx
                        &:before
                            font-size 40rpx
                            line-height 40rpx
                            color #E60000
                            position absolute
                            top 0px
                            right 0
                        i
                            position absolute
                            width 40rpx
                            text-align center
                            font-size 12rpx
                            color #FFFFFF
                            transform rotate(45deg)
                            top 7rpx
                            left 7rpx
                    .headPortrait
                        width 42rpx
                        height 42rpx
                        margin-right 15rpx
                        img
                            width 100%
                            height 100%
                    .info
                        h5
                            font-size 16rpx
                            color #333333
                            line-height 42rpx
                        p
                            font-size 14rpx
                            color #979EA7
        .submitPopUp
            border-radius 4rpx
            .van-dialog__header
                padding 0
                height 40rpx
                line-height 40rpx
                background #F0F7FF
                font-size 16rpx
                color #333333
            .van-dialog__content
                .submitPopUpContent
                    .info
                        .infoList
                            display flex
                            align-items center
                            padding 30rpx
                            .icon
                                width: 44rpx;
                                height: 44rpx;
                                background: linear-gradient(131deg, #FBA763 0%, #FF7D48 100%);
                                border-radius: 4rpx;
                                margin-right 20rpx
                                font-size 22rpx
                                text-align center
                                line-height 44rpx
                                color #fff
                            h4
                                p
                                    font-size 14rpx
                                    color #666666
                                    margin-bottom 5rpx
                                span
                                    font-size 18rpx
                                    color #0078FB
                            &.approvalPhase
                                border-bottom 1px solid #F0F0F0
                                .icon
                                    background: linear-gradient(131deg, #53B0FF 0%, #2978FF 100%);
                            &.approver
                                h4
                                    span
                                        color #FF7F4A
                .tips
                    padding 14rpx 20rpx 0
                    background #F8F8F8
                    font-size 14rpx
                    color #888888
            .van-dialog__footer
                background #F8F8F8
                .van-button
                    width 96rpx
                    height 32rpx
                    background: rgba(0,120,251,0.06);
                    border-radius: 2px;
                    border: 1px solid rgba(0,120,251,0.3);
                    font-size 14rpx
                    color #0078FB
                    margin 15rpx 20rpx
                    &:last-child
                        background #0078FB
                        color #fff
                        border none
    .btns
        height 60rpx
        padding 0 5rpx
        display flex
        align-items center
        justify-content center
        background #FFFFFF
        box-shadow: 0px 0px 6px 0px rgba(0,0,0,0.2);
        position: relative
        z-index 2
        button
            flex 1
            width 160rpx
            height 40rpx
            background: #0078FB
            border-radius: 2px;
            font-size 14rpx
            position relative
            color #fff
            margin 0 10rpx
            border-color #0078FB
</style>
